export const postgresErrorCodes = {
    errorCodes : {
        UNIQUE_VIOLATION : '23505'
    }
}